(function () {

  /* -----------------------------
     A) Measure mobile sticky header height
  ------------------------------ */
  function setStickyHeaderOffset() {
    var root = document.documentElement;

    if (window.innerWidth >= 990) {
      root.style.removeProperty('--mobileStickyHeaderH');
      return;
    }

    var header = document.querySelector('.site-header-main[data-site-header-sticky]');
    if (!header) return;

    var h = Math.ceil(header.getBoundingClientRect().height);
    root.style.setProperty('--mobileStickyHeaderH', h + 'px');
  }

  window.addEventListener('load', setStickyHeaderOffset);
  window.addEventListener('resize', setStickyHeaderOffset);
  window.addEventListener('orientationchange', setStickyHeaderOffset);

  if ('ResizeObserver' in window) {
    window.addEventListener('load', function () {
      var header = document.querySelector('.site-header-main[data-site-header-sticky]');
      if (!header) return;
      new ResizeObserver(setStickyHeaderOffset).observe(header);
      setStickyHeaderOffset();
    });
  }

  function getHeaderH() {
    var v = getComputedStyle(document.documentElement)
      .getPropertyValue('--mobileStickyHeaderH')
      .trim();
    var n = parseInt(v || '0', 10);
    return isNaN(n) ? 0 : n;
  }

  /* -----------------------------
     B) Find the real open menu panel by scanning the DOM
  ------------------------------ */
  function findMenuPanelByScan() {
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    var nodes = document.querySelectorAll('nav, aside, section, div');
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      // Must have links (menu-like)
      var links = el.getElementsByTagName('a');
      if (!links || links.length < 8) continue;

      var rect = el.getBoundingClientRect();
      if (rect.width < vw * 0.7) continue;
      if (rect.height < vh * 0.5) continue;

      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;

      // Prefer overlay-like elements
      var overlayLike = (cs.position === 'fixed' || cs.position === 'absolute' || cs.transform !== 'none');
      if (!overlayLike) continue;

      // Score: bigger + more links + closer to top
      var areaScore = (rect.width * rect.height) / (vw * vh);
      var linkScore = Math.min(links.length, 60) / 60;
      var topScore = 1 - Math.min(Math.max(rect.top, 0), 200) / 200;
      var score = (areaScore * 0.6) + (linkScore * 0.3) + (topScore * 0.1);

      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    }

    return best;
  }

  function applyMenuOffset(el, h) {
    // Force a viewport panel and move it down below the fixed header
    el.style.position = 'fixed';
    el.style.left = '0';
    el.style.right = '0';
    el.style.top = h + 'px';
    el.style.bottom = '0';
    el.style.height = 'calc(100vh - ' + h + 'px)';
    el.style.overflowY = 'auto';
    el.style.webkitOverflowScrolling = 'touch';
    el.style.zIndex = '9999';

    // Neutralize transforms that can cause the drawer to ignore top
    el.style.transform = 'none';
  }

  function enforceMenuOffsetForASecond() {
    if (window.innerWidth >= 990) return;

    var h = getHeaderH();
    if (!h) return;

    // Small buffer to avoid “slightly cut off” on iOS (tune 0 / 4 / 8)
    h = h + 0;

    var start = Date.now();
    var interval = setInterval(function () {
      if (Date.now() - start > 1200) {
        clearInterval(interval);
        return;
      }

      var panel = findMenuPanelByScan();
      if (panel) applyMenuOffset(panel, h);
    }, 60);
  }

  /* -----------------------------
     C) Run when hamburger is tapped
  ------------------------------ */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle], .site-header-menu-toggle')) {
      setStickyHeaderOffset();
      setTimeout(enforceMenuOffsetForASecond, 30);
      setTimeout(enforceMenuOffsetForASecond, 200);
    }
  });

})();
